import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ChatWidget from '../components/ChatWidget';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LocationPage = () => {
  const { slug } = useParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLocationPage = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${BACKEND_URL}/api/locations/${slug}`,
          { responseType: 'text' }
        );
        setHtml(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching location page:', err);
        setError('Location page not found');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchLocationPage();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0612] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-[#0a0612] flex items-center justify-center text-white">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">404</h1>
          <p className="text-gray-400">{error}</p>
        </div>
      </div>
    );
  }

  // Render the HTML content
  return (
    <>
      <div 
        className="location-page-container"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <ChatWidget />
    </>
  );
};

export default LocationPage;
